/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespSeoLinks_viewer$ref = any;
type PdpRespSimilarItemsGrid_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespContainerNotListed_viewer$ref: FragmentReference;
export type PdpRespContainerNotListed_viewer = {|
  +$fragmentRefs: PdpRespSimilarItemsGrid_viewer$ref & PdpRespSeoLinks_viewer$ref,
  +$refType: PdpRespContainerNotListed_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespContainerNotListed_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSeoLinks_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '71d31dc4422fcfe596d18667039b3f85';
module.exports = node;
